export default {
  methods: {
    toggleCardDarken (e, opts = {}) {
      const elt = selectElt(e, opts.root)
      elt.classList.toggle('darken')
    },
    addCardDarken (e, opts = {}) {
      const elt = selectElt(e, opts.root)
      elt.classList.add('darken')
    },
    removeCardDarken (e, opts = {}) {
      const elt = selectElt(e, opts.root)
      elt.classList.remove('darken')
    }
  }
}

function selectElt (e, root) {
  // Sometimes this function is used on a div that has a <span> inside an <a>
  // and the <span> has a z-index of 1. In this case, we need to traverse up
  // the DOM two levels to grab the div we want. This case is indicated by
  // root = false
  let elt

  if (root) {
    elt = e.target
  } else {
    // e.target is a span in the DOM like this
    // <div> <-- desired target
    //  <a href="...">
    //   <span></span> <-- actual target
    elt = e.target.parentNode.parentNode
  }

  return elt
}
